var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable } from "mobx";
export class GlobalAdminIdpIssuerProbeModel {
    constructor(container) {
        this.organizationId = "";
        this.issuerInput = "";
        this.probing = false;
        this.result = null;
        this.error = null;
        this.provisioningService = container.provisioningService;
    }
    setOrganizationId(organizationId) {
        this.organizationId = organizationId;
    }
    get canProbe() {
        return this.issuerInput.trim().length > 0 && !!this.organizationId && !this.probing;
    }
    updateIssuer(value) {
        this.issuerInput = value;
        this.result = null;
        this.error = null;
    }
    async probe() {
        if (!this.canProbe)
            return;
        this.probing = true;
        this.result = null;
        this.error = null;
        try {
            this.result = await this.provisioningService.probeIdpIssuer(this.organizationId, this.issuerInput.trim());
        }
        catch (e) {
            console.error("[IdpProbe] Probe request failed", e);
            this.error = "Could not run the probe. Check the backend logs.";
        }
        finally {
            this.probing = false;
        }
    }
}
__decorate([
    observable
], GlobalAdminIdpIssuerProbeModel.prototype, "issuerInput", void 0);
__decorate([
    observable
], GlobalAdminIdpIssuerProbeModel.prototype, "probing", void 0);
__decorate([
    observable
], GlobalAdminIdpIssuerProbeModel.prototype, "result", void 0);
__decorate([
    observable
], GlobalAdminIdpIssuerProbeModel.prototype, "error", void 0);
__decorate([
    computed
], GlobalAdminIdpIssuerProbeModel.prototype, "canProbe", null);
